export default "__VITE_ASSET__CavLuUuS__"